import { useState } from 'react';

import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { Box, Collapse, Typography } from '@mui/material';
import { useHistory, useParams } from 'react-router-dom';

import { colors, markets, transition } from '../../constants';

interface YearbookParams {
  year: string;
  market?: string;
  section?: string;
}

export function MarketsMenu() {
  const [open, setOpen] = useState(false);
  const { year, market } = useParams<YearbookParams>();
  const history = useHistory();

  const selected = markets.find((m) => m === market) ?? markets[0];

  const handleSelect = (newMarket: string) => {
    history.push(`/anuarios/${year}/${newMarket}/inicio`);
    setOpen(false);
  };

  return (
    <Box sx={{ position: 'relative', minWidth: 120, height: 40 }}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          border: `2px solid ${colors.orange}`,
          borderRadius: '24px',
          backgroundColor: 'transparent',
          backdropFilter: 'blur(6px)',
          zIndex: 10,
          overflow: 'hidden',
        }}>
        <Box
          onClick={() => setOpen((prev) => !prev)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2,
            py: 1,
            cursor: 'pointer',
            color: colors.white,
            transition,
            '&:hover': { color: colors.orange },
          }}>
          <Typography fontFamily="Figtree">{selected}</Typography>
          {open ? <ArrowDropUp /> : <ArrowDropDown />}
        </Box>

        <Collapse in={open} unmountOnExit>
          {markets
            .filter((m) => m !== selected)
            .map((market) => (
              <Typography
                key={market}
                fontFamily="Figtree"
                onClick={() => handleSelect(market)}
                sx={{
                  px: 2,
                  py: 1,
                  cursor: 'pointer',
                  color: colors.white,
                  transition,
                  '&:hover': { color: colors.orange },
                }}>
                {market}
              </Typography>
            ))}
        </Collapse>
      </Box>
    </Box>
  );
}
